import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { CertificateRecord } from './certificate-record';

export class CertificateRecordStateModel extends EntityStateModel<CertificateRecord> {}
